// import { DryMassWorksheetGridEntry, DryMassWorksheetGridControls } from './';
import moment from 'moment';
import config from './Config';

import { DryMassWorksheetGridEntry } from './DryMassWorksheetGridEntry';
import { DryMassWorksheetGridControls } from './DryMassWorksheetGridControls';
import { GridDefinition } from 'Components/WorksheetGrids';

const DryMassWorksheetGridDefinition: GridDefinition = {
  worksheetType: 'Moisture Content Dry Mass Reading',
  title: 'Moisture Content - Dry Mass Entry',
  shortTitle: 'Dry Mass Entry',
  query: {
    defaultParams: {
      IsReadyForDryMassEntry: true,
      DateInOven: () => ({ operator: '>=', value: moment().add(-10, 'day').format('YYYY-MM-DD') }),
      Limit: 300,
    },
    requiredParams: ['LaboratoryId', 'IsReadyForDryMassEntry'],
  },
  commonDataSettings: {},
  controlsComponent: DryMassWorksheetGridControls,
  entryComponent: DryMassWorksheetGridEntry,
  config,
  syncDialogSettings: {
    identifierPath: 'data.MoistureContentMeasurements.ContainerLabel',
    identifierHeader: 'Tare Id',
    excludedPaths: ['Measurement.Balance'],
  },
};

export { DryMassWorksheetGridDefinition };
